import MegaModal from './MegaModal';
import HTTP from './HTTP';
import { extend } from 'lodash-es';

export default class Tab {

	/**
	 *
	 * @param options ({})
	 * @param tabs
	 * @param instance
	 */
	constructor (options, tabs, instance) {
		this.attributes = [];
		this.title = '';
		this.ajax = null;
		this.action = () => {
			// empty function, user defined action from options
		};

		extend(this, options);

		this.createTabItem();
		this.dataAttributes(this.tabAnchor, this.attributes);
		this.initialize(tabs, instance);
	}

	/**
	 *
	 */
	createTabItem () {
		this.tabItem = document.createElement('li');
		this.tabAnchor = document.createElement('a');
		this.tabAnchor.appendChild(document.createTextNode(this.title));
	}

	/**
	 * Adds data attributes to a given element
	 * @param ele The target element
	 * @param attributes An array of attributes
	 */
	dataAttributes (ele, attributes) {
		if (this.attributes.length > 0 && this.attributes.every((x) => typeof x === 'object')) {
			attributes.forEach((attribute) => {
				ele.setAttribute(attribute.key, attribute.value);
			});
		}
	}

	/**
	 * Tabs can perform HTTP GET request when switching between each one, so it can get some data if required.
	 * This adds a loading spinner and removes it once complete.
	 * @param tabs The tabs object (contains all tabs)
	 * @param instance The modal instance
	 */
	tabAjaxHandler (tabs, instance) {
		let tabAjaxObj = this.ajax;

		let ajaxObj = {
			url: this.ajax.url,
			timeout: 5000,
			onSuccess: (responseData) => {
				if (instance instanceof MegaModal) {
					instance.bodyContent.classList.remove('loader');
				}

				tabs.disableTabs(false);

				tabAjaxObj.success.call(instance, responseData);
			},
			onFailure: (status, callbackData, responseText) => {
				if (instance instanceof MegaModal) {
					instance.bodyContent.classList.remove('loader');
				}

				tabAjaxObj.failure.call(instance, status, callbackData, responseText);
			},
		};

		tabs.disableTabs(true);

		let request = new HTTP();
		request.get(ajaxObj);

		if (instance instanceof MegaModal) {
			instance.bodyContent.classList.add('loader');
		}
	}

	initialize (tabs, instance) {
		this.tabTrigger = document.createEvent('Event');
		this.tabTrigger.initEvent('tabSelection', true, false);

		if (instance instanceof MegaModal) {
			this.tabAnchor.addEventListener('click', instance.removeBodyContent.bind(instance));
		}

		if (this.ajax !== null) {
			this.tabAnchor.addEventListener('click', this.tabAjaxHandler.bind(this, tabs, instance));
			this.tabAnchor.addEventListener('tabSelection', this.tabAjaxHandler.bind(this, tabs, instance));
		} else {
			this.tabAnchor.addEventListener('click', this.action.bind(this, tabs, instance));
			this.tabAnchor.addEventListener('tabSelection', this.action.bind(this, tabs, instance));
		}
	}

}
